function flatten(obj) {
  const toReturn = {};

  for (const prop of Object.keys(obj)) {
    if (!obj.hasOwnProperty(prop)) continue;

    if (typeof obj[prop] === 'object') {
      const flatObject = flatten(obj[prop]);

      for (const innerProp of Object.keys(flatObject)) {
        if (!flatObject.hasOwnProperty(innerProp)) continue;

        toReturn[`${prop}.${innerProp}`] = flatObject[innerProp];
      }
    } else {
      toReturn[prop] = obj[prop];
    }
  }
  return toReturn;
}

export { flatten };
